import gql from "graphql-tag"

export const GET_LEDYER_CONFIG = gql`
  query getLedyerConfig($id: ID!) {
    getLedyerConfig(id: $id) {
      id
      created
      updated
      baseUrl
      authUrl
      credentials {
        clientSecret
        clientId
      }
    }
  }
`
